import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ContactoService {
  API_URL = environment.apiURL + 'contacto';
  FR_URL = environment.apiURL + 'franquicias';

  constructor(private httpClient: HttpClient) {}
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  // Send Form Data
  sendFormRequest(data): Observable<any> {
    return this.httpClient.post<any>(this.API_URL, JSON.stringify(data), this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  sendFranquicias(data): Observable<any> {
    return this.httpClient.post<any>(this.FR_URL, JSON.stringify(data), this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }
  //
  // Error handling
  handleError(error): any {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
